/* CustomDisclaimer.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./CustomDisclaimer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var footerInformationStylesUnbounded = null;
var footerInformationStyles = null;
/**
 * Custom disclaimer to be displayed in the footer.
 *
 */
export function CustomDisclaimer(_ref) {
  var disclaimer = _ref.disclaimer;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _1n261g80 _4cvr1h6o", "_1ul9idpf _1tke1ejb _1yp21o8v _55c61o8v _tml11gjq _17mn1gjq _1bchidpf _1rbcidpf _1npc1b66 _1gic1b66 _1e091b66"])
  }, /*#__PURE__*/React.createElement(Box, {
    testId: "custom-disclaimer"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: disclaimer.tooltip,
    position: "top"
  }, disclaimer.url ? /*#__PURE__*/React.createElement("a", {
    href: disclaimer.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, disclaimer.text) : /*#__PURE__*/React.createElement("span", null, disclaimer.text))));
}